/* eslint-disable react/require-default-props */
import React from 'react'
import { CircularProgress } from '@material-ui/core'

import { formatDashboardNumber } from '../utils/formatDashboardNumber'

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

interface MetricCardProps {
  title: string
  value: number
  prev?: number
  diff?: number
  isPositive?: boolean
  showComparison?: boolean
  className?: string
  comparisonMonth?: string
  comparisonYear?: string
  comparisonStore?: string
  isPercent?: boolean
  isCurrency?: boolean
  isLoading?: boolean
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  prev = 0,
  diff = 0,
  isPositive = true,
  showComparison = false,
  className = '',
  comparisonMonth = '',
  comparisonYear = '',
  comparisonStore = '',
  isPercent = false,
  isCurrency = false,
  isLoading = false,
}) => {
  const formatValue = (val: number) => {
    if (isCurrency) {
      return val.toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 2,
      })
    }
    if (isPercent) {
      return `${val.toFixed(1)}%`
    }
    return formatDashboardNumber(val)
  }

  return (
    <div
      className={`bg-white rounded-2xl p-6 flex flex-col overflow-hidden ${className}`}
      style={montserratStyle}
    >
      <span className="text-base font-bold mb-1">{title}</span>
      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <span className="text-2xl md:text-3xl font-extrabold mb-2 leading-tight whitespace-nowrap">
          {formatValue(value)}
        </span>
      )}
      {showComparison && prev > 0 && (
        <div className="flex items-center gap-2">
          <span
            className="font-bold rounded-lg px-2 py-1 flex items-center text-base"
            style={{
              ...montserratStyle,
              background: isPositive ? '#C1FD96CC' : '#FFDBDB',
              color: '#1E1E1E',
            }}
          >
            {isPositive ? (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#47B960"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="mr-1"
              >
                <path d="M6 15l6-6 6 6" />
              </svg>
            ) : (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#E53935"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="mr-1"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            )}
            {`${diff.toFixed(1)}%`}
          </span>
          {comparisonMonth && comparisonYear && (
            <span className="text-gray-600 text-base">
              ({formatValue(prev)} del periodo {comparisonMonth} {comparisonYear})
            </span>
          )}
          {comparisonStore && (
            <span className="text-gray-600 text-base">
              ({formatValue(prev)} de la sucursal {comparisonStore})
            </span>
          )}
        </div>
      )}
    </div>
  )
}
